<div class="state-column">
    <h3 class="column-title">Display States</h3>
    <p class="column-hint">Select a state and configure its complete slot layout.</p>
    <div class="state-list">
        @for (state of allStates; track state) {
        <div class="state-item" [class.has-layout]="hasStateLayout(state)" [class.selected]="selectedState === state"
            (click)="stateSelected.emit(state)">
            <mat-icon class="state-icon">
                {{ hasStateLayout(state) ? 'check_circle' : 'radio_button_unchecked' }}
            </mat-icon>
            <span class="state-name">{{ state }}</span>
            @if (hasStateLayout(state)) {
            <span class="slot-count-badge">{{ getSlotCountLabel(state) }}</span>
            <button mat-icon-button class="remove-layout-btn" color="warn" matTooltip="Clear state layout"
                (click)="$event.stopPropagation(); removeLayout.emit(state)">
                <mat-icon>delete</mat-icon>
            </button>
            }
        </div>
        }
    </div>
</div>